module.exports = __webpack_public_path__ + "static/media/m_beard_balbo_round__oval_vector.01cbefc2.svg";